import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/jobs/changeOrdersReportActions'
import * as api from '../../../api/reports/jobs/changeOrdersReport'

function* changeOrdersReportGetJobList(action) {
  try {
    const payload = yield call(api.getJobList, action.filters)
    yield put({ type: constants.CHANGE_ORDERS_REPORT_GET_JOB_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CHANGE_ORDERS_REPORT_GET_JOB_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* changeOrdersReportGetOrganizationList(action) {
  try {
    const payload = yield call(api.getOrganizationList, action.filters)
    yield put({
      type: constants.CHANGE_ORDERS_REPORT_GET_ORGANIZATION_LIST.SUCCESS,
      payload
    })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CHANGE_ORDERS_REPORT_GET_ORGANIZATION_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* changeOrdersReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.CHANGE_ORDERS_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CHANGE_ORDERS_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */

function* watchchangeOrdersReportGetJobList() {
  yield takeLatest(constants.CHANGE_ORDERS_REPORT_GET_JOB_LIST.ACTION, changeOrdersReportGetJobList)
}

function* watchchangeOrdersReportGetOrganizationList() {
  yield takeLatest(
    constants.CHANGE_ORDERS_REPORT_GET_ORGANIZATION_LIST.ACTION,
    changeOrdersReportGetOrganizationList
  )
}

function* watchchangeOrdersReportGetFullReport() {
  yield takeLatest(
    constants.CHANGE_ORDERS_REPORT_GET_FULL_REPORT.ACTION,
    changeOrdersReportGetFullReport
  )
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchchangeOrdersReportGetOrganizationList),
    fork(watchchangeOrdersReportGetFullReport),
    fork(watchchangeOrdersReportGetJobList)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/jobs/changeOrdersReportSaga.js